/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples

// Images
import bgFront from "assets/images/rotating-card-bg-front.jpeg";
import bgBack from "assets/images/rotating-card-bg-back.jpeg";

// Energy save zone 컴포넌트
import RotatingCard from "layouts/components/rotatingCard";
import RotatingCardFront from "layouts/components/rotatingCard/RotatingCardFront";
import RotatingCardBack from "layouts/components/rotatingCard/RotatingCardBack";
import DefaultInfoCard from "./energy/DefaultInfoCard";

function EnergySaveZoneInfo() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={
                  <>
                    ENERGY SAVE
                    <br />
                    ZONE
                  </>
                }
                description="에너지 절약을 실현하는 효율적인 조명 솔루션"
              />
              <RotatingCardBack
                image={bgBack}
                title="에너지 절약을 실현하는 효율적인 조명 솔루션"
                action={{
                  route: "/products#energy-save-zone",
                  label: "제품으로 이동",
                }}
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="lightbulb"
                  title="1. 전력 절감"
                  description={
                    <>
                      광효율이 높은 제품은 더 적은 전력으로도 더 많은 빛을 제공
                      <br />
                      전기 사용량을 줄이고, 전력 비용을 절감하는 데 도움
                    </>
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="eco"
                  title="2. 환경 보호"
                  description={
                    <>
                      에너지 소비를 줄이고
                      <br />
                      지속 가능한 환경 보호에 기여
                    </>
                  }
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="savings"
                  title="3. 장기적인 비용 절감"
                  description={
                    <>
                      초기 투자비용으로
                      <br />
                      장기적인 전력 절감 및 전체 비용 감소
                    </>
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  icon="trending_up"
                  title="4. 효율성 향상"
                  description={
                    <>
                      더 많은 빛을 더 적은 에너지로 제공
                      <br />
                      작업의 효율성 및 생산성 증가
                    </>
                  }
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default EnergySaveZoneInfo;
